import { makeStyles } from '@material-ui/core';

export const styles = makeStyles((theme) => ({
  defaultIcon: {
    height: 14,
    width: 14,
    cursor: 'pointer',
  },
}));
